import { Avatar } from '@mui/material';
import styled from 'styled-components';

import { TStyledAvatarProps } from '@/shared/components/ui/avatar/avatar.types';

export const AvatarContainer = styled.span`
  && {
    display: inline-flex;
    gap: 0.25rem;
    align-items: center;
  }
`;

export const StyledAvatar = styled(Avatar)<TStyledAvatarProps>`
  && {
    width: 1rem;
    height: 1rem;
    background: ${({ theme, $color }) =>
      $color
        ? theme.palette.status[$color].stroke
        : theme.palette.primary.light};

    .MuiTypography-root {
      color: ${({ theme, $color }) =>
        $color
          ? theme.palette.status[$color].text
          : theme.palette.primary.contrastText};
    }
  }
`;
